const isIntegerRegex = /^\d+$/;

export const isPositiveInteger = (value: string | null): boolean => {
  if (value === null || value === undefined) {
    return false;
  }

  return isIntegerRegex.test(value);
};

const numberFormat = new Intl.NumberFormat("de-CH");

export const formatNumber = (value: string | null) => {
  if (value == null || value === "") {
    return "";
  }

  const numValue = parseInt(value);
  if (isNaN(numValue) || String(numValue) !== value) {
    return value;
  }

  return numberFormat.format(numValue).replace(/'/g, "’").replace(/\s/g, "’");
};
